 <template>
	<v-sheet>
		<p class="mw-h3">Important Dates</p>
		<v-row>
			<v-col>
				<v-combobox
				v-model="dateKeys"
				:items="dateKeyOptions"
				label="Important Dates"
				multiple
				chips
				></v-combobox>
			</v-col>
			<v-col v-if="dateKeys" >
				<div v-for="key in dateKeys" :key="key">
					<DateTimeField 
					:object="project.dates" 
					type="date" 
					:label="prettyPrint(key, 'TITLE')" 
					:objectKey="key"
					v-on:updated="dateUpdated"
					></DateTimeField>
				</div>
			</v-col>
		</v-row>
		<p class="mw-h3">Slots</p>
		<v-btn color="primary" @click="copySlotsFromAppointments">Copy slots from appointments</v-btn>&nbsp;
		<v-dialog v-model="displayImport">
			<template v-slot:activator="{ on }">
				<v-btn color="primary" v-on="on">Import</v-btn>
			</template>
			<Import :defaults="{}" :initialFields="['name', 'date', 'startTime', 'endTime']" v-on:complete="completeImport"></Import>
		</v-dialog>
		&nbsp;
		<v-btn color="green" dark @click="slots.push({name: '', date: '', startTime: '00:00', endTime: '00:00'})">Add slot</v-btn>
		<div v-if="slots && slots.length">
			<v-simple-table>
				<thead>
					<tr>
						<th>Name</th>
						<th>Date</th>
						<th>Start</th>
						<th>End</th>
						<th width="10%"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(slot, index) in slots" :key="index">
						<td>
							<v-text-field v-model="slot.name" label="Name"></v-text-field>
						</td>
						<td>
							<DateTimeField 
								:object="slot" 
								type="date" 
								label="Date" 
								objectKey="date"
								v-on:updated="updateSlot"
							></DateTimeField>
						</td>
						<td>
							<DateTimeField 
								:object="slot" 
								type="time" 
								label="Start" 
								objectKey="startTime"
								v-on:updated="updateSlot"
							></DateTimeField>
						</td>
						<td>
							<DateTimeField 
								:object="slot" 
								type="time" 
								label="End" 
								objectKey="endTime"
								v-on:updated="updateSlot"
							></DateTimeField>
						</td>
						<td>
							<v-btn icon @click="slots.splice(index, 1)"><v-icon>mdi-close</v-icon></v-btn>
						</td>
					</tr>
				</tbody>
			</v-simple-table>
		</div>
		<div class="mt-5">
			<p class="">Participant access: </p>
			<NamedUrlField type="scheduling" :id="project.id" label="Custom URL"></NamedUrlField>
			<small color="secondary"><b>Default URL: </b> <a v-bind:href="schedulingUrl" target="blank">{{schedulingUrl}}</a> </small>
		</div>
		<p class="text-right mt-3">
			<v-btn
				color="green"
				dark
				class="mr-4"
				@click="save"
				>Save
			</v-btn>			
		</p>
	</v-sheet>
</template>

<script>
	import Vue from 'vue'
	
	import Vuex from 'vuex'
	import {prettyPrint} from "../../assets/utilities"
	import DateTimeField from "../tools/DateTimeField"
	import NamedUrlField from "../tools/NamedUrlField"
	import Import from "../tools/Import"

	export default	{
		name: "EditProjectDates", 
		props: {
			project: {type: Object},
		},
		data: () => {
			return {
				displayImport: false,
				dateKeys: false, 
				slots: []
			}
		},
		components: {
			DateTimeField: DateTimeField,
			NamedUrlField: NamedUrlField,
			Import: Import
		},
		computed:{
			...Vuex.mapState({
				existingSlots: function(state){
					const self = this;
					let slots = state[state.auth.view].projectSlots.find( p => p.id == self.project.id);
					if( slots ){
						return slots.slots;
					}
					else{
						return [];
					}
				}
			}), 
			dateKeyOptions: function(){
				let keys = [ 'start', 'end' ]
				if( this.project.dates){
					keys = keys.concat( Object.keys(this.project.dates)) 
				}
				return keys
			},
			schedulingUrl(){
				return "/scheduling/"  +  this.project.id
			} 
		},
		methods:{
			prettyPrint: prettyPrint,
			dateUpdated(date, key){
				this.project.dates[key] = date[key];
			},
			copySlotsFromAppointments(){
				const self = this;
				let appointments = this.$store.state.admin.appointments.filter( a => a.dateTime && a.project == self.project.id )
				if( !appointments ){ return; }
				appointments.forEach( a => {

					let slot = {
						name: '', 
						date: Vue.moment(a.dateTime.toDate()).format("YYYY-MM-DD"), 
						startTime: Vue.moment(a.dateTime.toDate()).format("HH:mm"), 
						endTime: Vue.moment( a.dateTime.toDate()  ).add(1, 'hours').format("HH:mm")
					}
					slot.start = slot.date + " " + slot.startTime;
					slot.end = slot.date + " "  + slot.endTime;
					self.slots.push( slot )
				})
			},
			updateSlot(slot){
				slot.start = slot.date + " " + slot.startTime;
				slot.end = slot.date + " "  + slot.endTime;
			},
			save(){
				const self = this;
				const slots = {}
				self.slots.forEach( slot => slots[slot.name] = slot )
				self.$store.dispatch("updateDoc", {
					doc: "projectSlots/" + self.project.id, 
					action: 'set', 
					data: {slots: slots}
				})
				self.$emit('save')
			},
			completeImport(slots){
				const self = this;
				slots.forEach( slot => {
					slot.date =  Vue.moment(slot.date, "DD/MM/YYYY").format('YYYY-MM-DD');
					slot.start = slot.date + " " + slot.startTime;
					slot.end = slot.date + " "  + slot.endTime;
					self.slots.push( slot )
				})
				self.displayImport = 0 
			}
		},
		created: function(){
			var self = this;	
			this.$store.dispatch("fetchProjectAppointments", this.project.id )
			this.$store.dispatch("fetchProjectSlots", this.project.id )

			if( self.project.dates ){
				self.dateKeys = Object.keys(self.project.dates);
				self.dateKeys.forEach( function(key) {
					if( self.project.dates[key].toDate ){
						self.project.dates[key] = Vue.moment(self.project.dates[key].toDate()).format("YYYY-MM-DD")
					}
				})
			}
			else{
				self.project.dates = {
					start:null, 
					end: null
				}
				self.dateKeys  = Object.keys(self.project.dates);
			}
		},
		watch: {
			existingSlots: { 
				immediate: true,
				handler: function(es){
					if( es ){
						this.slots = Object.keys(es).filter( key => key !== "id").map( key => es[key] )
					}
				}
			}
		},

	}
</script>